import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';
import getDefaultName from '../defaults/get-default-name';

export function getName() {
  return getDefaultName('Combinations');
}

export function getColumnsMetadata() {
  return _.defaults({
    AdPreview: ['Headline1', 'Headline2', 'Headline3', 'Description1', 'Description2'],
    Headline1: [],
    Headline2: [],
    Headline3: [],
    Description1: [],
    Description2: [],
  }, PerformanceMetricsColumns);
}
